import { Component, OnInit, TemplateRef } from '@angular/core';
import { CompraService } from '../../../services/compra.service';
import { Compra } from './../../../models/compra';
import { Router } from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SweetMessage } from '../../../config/sweet-message';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CompraModalComponent } from '../../../components/modals/compra-modal/compra-modal.component';
import { SessionService } from '../../../services/session.service';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { ParametroService } from '../../../services/parametro.service';
import { Pagination } from '../../../models/pagination';
import * as moment from 'moment';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { environment } from '../../../../environments/environment';
import { ReenviarCorreoComponent } from '../../modals/reenviar-correo/reenviar-correo.component';
import { EmitirRetencionCompraModalComponent } from '../../modals/emitir-retencion-compra-modal/emitir-retencion-compra-modal.component';
import { RetencionCompraModalComponent } from '../../modals/retencion-compra-modal/retencion-compra-modal.component';

@Component({
  selector: 'app-liquidacion-compra-list',
  templateUrl: './liquidacion-compra-list.component.html',
  styleUrls: ['./liquidacion-compra-list.component.css'],
  providers: [ CompraService, ParametroService ]
})


export class LiquidacionCompraListComponent implements OnInit {
	public title: String;
	public liquidacionesc: Array<Compra> = [];
	public msg: SweetMessage;
	public bsModalRef: BsModalRef;
	public bsModalRef2: BsModalRef;
	public loading = false;
	public observacion: String;
	public compra_anulada: Compra;
	public numero_decimales: number;
    public format_decimal: String;
	public pagination: Pagination;
	public Mod_FactElec: string;
	public factelec_api: String;
	constructor(
		public CompraService: CompraService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private modalService: BsModalService,
		private ss: SessionService,
		private parametroService: ParametroService,
		
	) {
		this.title = "Compras";
		//this.busy = false;
		this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.pagination = new Pagination();
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.factelec_api = environment.factelec_api;
	}

	ngOnInit() {
		this.msg = new SweetMessage();
		
		this.loading = true;
		let p1 = this.getParamNumeroDecimales();
		let p2 = this.getCompras();
		
		Promise.all([p1,p2]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	isAnulable(venta: Compra){

        return true;


        /*let f = moment();
        let fecha = f.format("YYYY") + "-" + f.format("MM") + "-01";
        let fecha_inicio = moment(fecha,"YYYY-MM_DD").format('YYYY-MM-DD');
        let fecha_fin = moment().endOf('month').format('YYYY-MM-DD');
        let fecha_emision = moment(venta.fecha_emision.toString(),"YYYY-MM_DD");

        return fecha_emision.isSameOrAfter(fecha_inicio) && fecha_emision.isSameOrBefore(fecha_fin);*/
    }
    onRide(compra){
        if(this.CodEst(compra) === 'btn-success'){
            const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/ride/" + compra.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
		    this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
        }
    }

    onXML(compra){
        if(this.CodEst(compra) === 'btn-success'){            
            const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/xml/" + compra.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
            this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
        }
    }

    CodEst(compra){
		let cod_ests = ['NAT', 'NFIR', 'NLOG', 'DEV', 'TOT', 'FEC'];
		let result = cod_ests.filter(cod_est => cod_est === compra.cod_est);

		if( result.length > 0 ){
			return 'btn-danger';
		}

		cod_ests = ['VAL', 'PPR', 'EP'];
		result = cod_ests.filter(cod_est => cod_est === compra.cod_est);

		if( result.length > 0 ){
			return 'btn-warning';
		}

		cod_ests = ['AUT'];
		result = cod_ests.filter(cod_est => cod_est === compra.cod_est);

		if( result.length > 0 ){
			return 'btn-success';
		}
    }
	setEstadoPago(estado_pago){
		if( estado_pago === "P" ){
			return "Pendiente";
		}else{
			return "Cancelado";
		}
	}

	getCompras(){
		return new Promise((resolve, reject) => {
			let now = moment();
			let tipo_comprobante_id = "";
			// if(this.Mod_FactElec){
			// 	tipo_comprobante_id = "13";
			// }
			// else{
			// 	tipo_comprobante_id = "12";
			// }

       		
			this.CompraService.getAll("?page=" + this.pagination.current_page + "&per_page=10&fecha_emision="+moment(now.format("YYYY-MM-DD"), moment.ISO_8601).format()+"&embed=estadobitacora,proveedor,retencion,tipocomprobante&sort=-fecha_emision,-secuencial&in[tipo_comprobante_id]=12,13&usuario_id="+this.ss.getData('usuario_id')).subscribe(
				res => {
					if( !res.data.length ){
						this.liquidacionesc = [];
					}else{
						this.liquidacionesc = res.data;
						// Paginación
						this.pagination.current_page = res.current_page;
						this.pagination.from = res.from;
						this.pagination.to = res.to;
						this.pagination.total = res.total;
						this.pagination.last_page = res.last_page;
						this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
						this.pagination.prev_disabled = this.pagination.current_page === 1;
					}
					resolve();
				},
				err => {
					this.liquidacionesc = [];
					reject();
				}
			);
		});
	}

	getIndexNumber(i){
        return this.pagination.from+i;
	}
	
	next(){
        this.pagination.current_page++;
        this.loading = true;
		this.getCompras().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	prev(){
        this.pagination.current_page--;
        this.loading = true;
		this.getCompras().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	first(){
        this.pagination.current_page = 1;
        this.loading = true;
		this.getCompras().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	last(){
        this.pagination.current_page = this.pagination.last_page;
        this.loading = true;
		this.getCompras().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}
	parseTipo(tipo){
		if( tipo === "CR" ){
			return "Crédito";
		}else{
			return "Contado";
		}
    }

	showModal(){

	}

	onShow(id){
		const initialState = {compra_id: id, numero_decimales: this.numero_decimales};
		this.bsModalRef = this.modalService.show(CompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onEdit(compra) {
		this.storage.setItem("compra", compra).subscribe(() => {
			this.NavRoute.navigate(['/compras/compras-edit']);
		});
	}

	/*onDelete(id){
		this.msg.showMessage('delete-confirm-message').then(
			res => {
				if(res == "ok"){
					this.CompraService.delete(id).subscribe(
						res => {
							if(res.message){
								this.getCompras();
								this.msg.showMessage('success-message',res.message);
							}
						},
						err => {
							this.msg.showMessage('error-message', err);
						}
					);
				}
			}
		);
	}*/

	getNumeroDocumento(compra){
		return compra.serie + "-" + compra.punto_emision + "-" + compra.secuencial;
	}

	openModalObservacionLiquidacion(template: TemplateRef<any>, compra) {
        if( compra.status === 'A' && this.isAnulable(compra) ){
            if(compra.tipo_comprobante_id.toString() === "13"){
                let preg = "Recuerda que para anular algún comprobante primero debes anularlo desde <a href='https://declaraciones.sri.gob.ec/tuportal-internet/' target='_blank'>https://declaraciones.sri.gob.ec/tuportal-internet/</a>, posteriormente podrás anularlo desde esta opción. ¿Estás seguro que deseas continuar?";
                const initialState = { Pregunta: preg, Respuesta:false };
                this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
                
                this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
                    if(Respuesta == true){
                        this.observacion = compra.observacion;
                        this.compra_anulada = compra;
                        this.bsModalRef = this.modalService.show(template);
                        this.bsModalRef2 = this.bsModalRef;
                    }
                });
            }else{
                this.observacion = compra.observacion;
                this.compra_anulada = compra;
                this.bsModalRef = this.modalService.show(template);
                this.bsModalRef2 = this.bsModalRef;
            }
        }
    }

	openModalObservacion(template: TemplateRef<any>, compra: Compra) {
		this.observacion = compra.observacion;
		this.compra_anulada = compra;
		this.bsModalRef = this.modalService.show(template);
		this.bsModalRef2 = this.bsModalRef;
	}

	anularLiquidacionCompra(){
		this.bsModalRef2.hide();
		let preg = "¿Está seguro de querer anular el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.compra_anulada.observacion = this.observacion.toString().trim();
                this.compra_anulada.usuario_id = this.ss.getData("usuario_id");
                this.compra_anulada.empresa_id = this.ss.getData("empresa_id");
				this.observacion  = "";
				
				this.loading = true;

				this.CompraService.anular(this.compra_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.compra_anulada = new Compra();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getCompras().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
    }

	anularCompra(){
		this.bsModalRef2.hide();
		let preg = "¿Está seguro de querer eliminar el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.compra_anulada.observacion = this.observacion.toString().trim();
				this.compra_anulada.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";
				
				this.loading = true;

				this.CompraService.anular(this.compra_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.compra_anulada = new Compra();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getCompras().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
	}

	openEmitirRetencionCompraModal(compra) {
		const initialState = { compra_id: compra.id, modal: true };
        this.bsModalRef = this.modalService.show(EmitirRetencionCompraModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
        
        let promise = new Promise((resolve, reject) => {
			this.bsModalRef.content.cerrarModal.take(1).subscribe(value => {
				resolve(value.isSaved);
			})
		});

		promise.then(isSaved => {
			if( !isSaved ) return;

			this.loading = true;
			this.getCompras().then(
				res => this.loading = false,
				err => this.loading = false,
			);
		});
    }
    
    openVerRetencion(retencion_id){
        const initialState = {retencion_id: retencion_id};
        this.bsModalRef = this.modalService.show(RetencionCompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }
	
	onStatusElectronica(compra){
		let msn = "";
		msn += "<p>Estado de Factura Electrónica</p>";
        msn += "<p><b style='font-size:24px;'>"+compra.estadobitacora.descripcion+"</b></p>";
    
        this.msg.showMessage('single-message', msn);
    }

    OnReenviar(compra){
        const initialState = { nombre: compra.proveedor.nombre_comercial, correo: compra.proveedor.correo, autorizacion: compra.numero_autorizacion };
		this.bsModalRef = this.modalService.show(ReenviarCorreoComponent, Object.assign({}, {initialState}));
    }
}





// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/liquidacion-compra-list/liquidacion-compra-list.component.ts